import { Config } from "@/Kernel/Config";
import { PackageManager } from "@/Kernel/PackageManager";
import { Authentication } from "@/Kernel/Authentication";

class Kernel {
  /**
   * If the Kernel is running.
   * @type {boolean}
   */
  _loaded = false;

  /**
   * If the Kernel has been built but is not running.
   * @type {boolean}
   */
  _built = false;

  /**
   * The Package Manager service
   * @type {PackageManager}
   */
  _packageManager;

  /**
   * The Config
   * @type {ConfigClass}
   */
  _config = null;

  /**
   *
   * @type {vuex}
   */
  _store = null;

  /**
   *
   * @type {vue}
   */
  _vueInstance = null;

  /**
   * @type {Object}
   */
  _locale;

  constructor() {
    this._packageManager = new PackageManager();
    this._config = Config;
    this._locale = {};
  }

  /**
   * Warm up the cache and load up the application kernel
   * @returns {Promise<Kernel>}
   */
  warmUp() {
    return new Promise(resolve => {
      Authentication.init();
      resolve();
    });
  }

  /**
   * Register the specific Vue instance with the Kernel.
   * @param vue
   */
  registerVue(vue) {
    if (this._vueInstance != null) {
      throw new Error(
        "A Vue instance has already been registered with the kernel."
      );
    }
    this._vueInstance = vue;
  }

  /**
   * Register a VueX store with the Kernel.
   * @param vuex {vuex}
   */
  registerStore(vuex) {
    if (this._store != null) {
      throw new Error(
        "A Vuex store has already been registered with the kernel."
      );
    }
    this._store = vuex;
  }

  /**
   * Register a new package with the PackageManager
   * @param pkg
   */
  registerPackage(pkg) {
    this._packageManager.registerPackage(pkg);
  }

  registerLocale(translations, prefix = null) {
    // this.getLocale().loadTranslations(translations, prefix);
  }

  registerRoutes() {}
  configureContainer() {}

  /**
   * Gets the assigned vue instance from the kernel.
   * @returns {vue}
   * @throws {Error} If a vue instance has not yet been registered.
   */
  getVueInstance() {
    if (this._vueInstance == null) {
      throw new Error(
        "A Vue instance has not been registered with the kernel."
      );
    } else {
      return this._vueInstance;
    }
  }

  /**
   * Get the VueX store
   * @returns {vuex}
   */
  getStore() {
    return this._store;
  }

  /**
   * Get the Locale Parser
   * @returns {Object}
   */
  getLocale() {
    return this._locale;
  }

  /**
   * @throws Error if the kernel is not loaded.
   * @returns {ConfigClass}
   */
  getConfig() {
    if (!this._loaded) {
      throw new Error("Unable to get config as Kernel is not loaded.");
    }
    return this._config;
  }

  build() {
    if (this._built) {
      throw new Error("Kernel is already built and cannot be rebuilt.");
    }
    this._packageManager.preload(this);
    this._built = true;
  }

  run() {
    this.getVueInstance().use(this._packageManager);
    return new Promise(resolve => {
      this._loaded = true;
      this._packageManager.initializePackages(this);
      resolve();
    });
  }
}

export const KernelInterface = new Kernel();
